import React, { useContext } from 'react';
import { Box, Theme } from '@bechtel/gds';
import { MultipleScopeStyled } from './styled';
import { ThemeContext } from 'styled-components';

export const MultipleScopeIcon = () => {
  const { colors } = useContext<Theme>(ThemeContext);
  return (
    <Box flexDirection={{ sm: 'column' }}>
      <Box mb={{ sm: '100' }}>
        <MultipleScopeStyled mr={{ sm: '100' }} bgColor={String(colors.bechtel.blue[300])}></MultipleScopeStyled>
        <MultipleScopeStyled bgColor={String(colors.green[300])}></MultipleScopeStyled>
      </Box>
      <Box>
        <MultipleScopeStyled mr={{ sm: '100' }} bgColor={String(colors.orange[300])}></MultipleScopeStyled>
        <MultipleScopeStyled bgColor={String(colors.purple[300])}></MultipleScopeStyled>
      </Box>
    </Box>
  );
};
